module.exports = __webpack_public_path__ + "static/media/login.c76429a4.svg";